/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AISystemCurrentState } from '../model';
// @ts-ignore
import type { AISystemRegistrationStatus } from '../model';
// @ts-ignore
import type { AISystemRunScope } from '../model';
// @ts-ignore
import type { AddCommentRequest } from '../model';
// @ts-ignore
import type { AddProjectUserToProject } from '../model';
// @ts-ignore
import type { BulkUpdateRequirementsRequest } from '../model';
// @ts-ignore
import type { Comment } from '../model';
// @ts-ignore
import type { Framework } from '../model';
// @ts-ignore
import type { GeographicScope } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { Log } from '../model';
// @ts-ignore
import type { PaginatedResultFramework } from '../model';
// @ts-ignore
import type { PaginatedResultRequirementBase } from '../model';
// @ts-ignore
import type { Project } from '../model';
// @ts-ignore
import type { ProjectCreate } from '../model';
// @ts-ignore
import type { ProjectExpandedPaginated } from '../model';
// @ts-ignore
import type { ProjectExpandedSorting } from '../model';
// @ts-ignore
import type { ProjectFrameworkCreateRequest } from '../model';
// @ts-ignore
import type { ProjectImportAccepted } from '../model';
// @ts-ignore
import type { ProjectImportPreview } from '../model';
// @ts-ignore
import type { ProjectPaginated } from '../model';
// @ts-ignore
import type { ProjectRegistrationStatusUpdate } from '../model';
// @ts-ignore
import type { ProjectSorting } from '../model';
// @ts-ignore
import type { ProjectType } from '../model';
// @ts-ignore
import type { ProjectUpdate } from '../model';
// @ts-ignore
import type { ProjectUser } from '../model';
// @ts-ignore
import type { ProjectUserPaginated } from '../model';
// @ts-ignore
import type { ProjectUserRoleUpdate } from '../model';
// @ts-ignore
import type { RequirementStatus } from '../model';
// @ts-ignore
import type { Roles } from '../model';
// @ts-ignore
import type { UserSorting } from '../model';
/**
 * ProjectsApi - axios parameter creator
 */
export const ProjectsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Assign project roles to a user.
         * @summary Add Project User Role
         * @param {string} userId 
         * @param {string} projectId 
         * @param {ProjectUserRoleUpdate} projectUserRoleUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProjectUserRole: async (userId: string, projectId: string, projectUserRoleUpdate: ProjectUserRoleUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addProjectUserRole', 'userId', userId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('addProjectUserRole', 'projectId', projectId)
            // verify required parameter 'projectUserRoleUpdate' is not null or undefined
            assertParamExists('addProjectUserRole', 'projectUserRoleUpdate', projectUserRoleUpdate)
            const localVarPath = `/projects/{project_id}/users/{user_id}/roles`
                .replace('{user_id}', encodeURIComponent(String(userId)))
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectUserRoleUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add user to project
         * @summary Add Project User To Project
         * @param {string} projectId 
         * @param {AddProjectUserToProject} addProjectUserToProject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProjectUserToProject: async (projectId: string, addProjectUserToProject: AddProjectUserToProject, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('addProjectUserToProject', 'projectId', projectId)
            // verify required parameter 'addProjectUserToProject' is not null or undefined
            assertParamExists('addProjectUserToProject', 'addProjectUserToProject', addProjectUserToProject)
            const localVarPath = `/projects/{project_id}/users`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addProjectUserToProject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk update requirements.
         * @summary Bulk Update Requirements
         * @param {string} projectId 
         * @param {BulkUpdateRequirementsRequest} bulkUpdateRequirementsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateRequirements: async (projectId: string, bulkUpdateRequirementsRequest: BulkUpdateRequirementsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('bulkUpdateRequirements', 'projectId', projectId)
            // verify required parameter 'bulkUpdateRequirementsRequest' is not null or undefined
            assertParamExists('bulkUpdateRequirements', 'bulkUpdateRequirementsRequest', bulkUpdateRequirementsRequest)
            const localVarPath = `/projects/{project_id}/requirements`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateRequirementsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new project.
         * @summary Create Project
         * @param {ProjectCreate} projectCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject: async (projectCreate: ProjectCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectCreate' is not null or undefined
            assertParamExists('createProject', 'projectCreate', projectCreate)
            const localVarPath = `/projects/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a comment to the AI system and notify its owners and prior participants.
         * @summary Create Project Comment
         * @param {string} projectId 
         * @param {AddCommentRequest} addCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectComment: async (projectId: string, addCommentRequest: AddCommentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('createProjectComment', 'projectId', projectId)
            // verify required parameter 'addCommentRequest' is not null or undefined
            assertParamExists('createProjectComment', 'addCommentRequest', addCommentRequest)
            const localVarPath = `/projects/{project_id}/comments`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCommentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Project Frameworks Endpoint
         * @param {string} projectId 
         * @param {ProjectFrameworkCreateRequest} projectFrameworkCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectFrameworksEndpoint: async (projectId: string, projectFrameworkCreateRequest: ProjectFrameworkCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('createProjectFrameworksEndpoint', 'projectId', projectId)
            // verify required parameter 'projectFrameworkCreateRequest' is not null or undefined
            assertParamExists('createProjectFrameworksEndpoint', 'projectFrameworkCreateRequest', projectFrameworkCreateRequest)
            const localVarPath = `/projects/{project_id}/frameworks`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectFrameworkCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a project by ID.  ``projects:delete`` deletes it in any registration status. While an AI System is not registered (draft, pending or rejected), its creator and the organization\'s registration reviewers may delete it too.
         * @summary Delete Project
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('deleteProject', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Project
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProject: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProject', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Comments left on the AI system itself (not on its controls, risks or assets).
         * @summary Get Project Comments
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectComments: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectComments', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/comments`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all frameworks for a project.
         * @summary Get Project Frameworks
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [sortBy] 
         * @param {string | null} [sortDir] 
         * @param {string | null} [name] 
         * @param {boolean | null} [isFrameworkLatestVersion] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectFrameworks: async (projectId: string, page?: number, size?: number, sortBy?: string | null, sortDir?: string | null, name?: string | null, isFrameworkLatestVersion?: boolean | null, exactMatch?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectFrameworks', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/frameworks`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDir !== undefined) {
                localVarQueryParameter['sort_dir'] = sortDir;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (isFrameworkLatestVersion !== undefined) {
                localVarQueryParameter['is_framework_latest_version'] = isFrameworkLatestVersion;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exact_match'] = exactMatch;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get activity logs for an AI system.
         * @summary Get AI System Logs
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectLogs: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectLogs', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/logs`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Project Requirements
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [sortBy] 
         * @param {string | null} [sortDir] 
         * @param {string | null} [name] 
         * @param {string | null} [assignedTo] 
         * @param {string | null} [frameworkCode] 
         * @param {RequirementStatus | null} [status] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectRequirements: async (projectId: string, page?: number, size?: number, sortBy?: string | null, sortDir?: string | null, name?: string | null, assignedTo?: string | null, frameworkCode?: string | null, status?: RequirementStatus | null, exactMatch?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectRequirements', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/requirements`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDir !== undefined) {
                localVarQueryParameter['sort_dir'] = sortDir;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (assignedTo !== undefined) {
                localVarQueryParameter['assigned_to'] = assignedTo;
            }

            if (frameworkCode !== undefined) {
                localVarQueryParameter['framework_code'] = frameworkCode;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exact_match'] = exactMatch;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List users who have a role on the project (paginated).
         * @summary Get Project Users
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {UserSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrEmail] 
         * @param {Roles | null} [role] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectUsers: async (projectId: string, page?: number, size?: number, sortBy?: UserSorting | null, descending?: boolean | null, nameOrEmail?: string | null, role?: Roles | null, exactMatch?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectUsers', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/users`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (nameOrEmail !== undefined) {
                localVarQueryParameter['name_or_email'] = nameOrEmail;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exact_match'] = exactMatch;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get projects.
         * @summary Get Projects
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {ProjectSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [name] 
         * @param {ProjectType | null} [type] 
         * @param {Array<string> | null} [lifecycleStages] Filter by AI lifecycle stages.
         * @param {Array<AISystemRegistrationStatus> | null} [registrationStatus] Filter by one or more registration statuses.
         * @param {string | null} [createdById] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjects: async (page?: number, size?: number, sortBy?: ProjectSorting | null, descending?: boolean | null, name?: string | null, type?: ProjectType | null, lifecycleStages?: Array<string> | null, registrationStatus?: Array<AISystemRegistrationStatus> | null, createdById?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/projects/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (lifecycleStages) {
                localVarQueryParameter['lifecycle_stages'] = lifecycleStages;
            }

            if (registrationStatus) {
                localVarQueryParameter['registration_status'] = registrationStatus;
            }

            if (createdById !== undefined) {
                localVarQueryParameter['created_by_id'] = createdById;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get expanded projects.
         * @summary Get Projects Expanded
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {ProjectExpandedSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [name] 
         * @param {ProjectType | null} [type] 
         * @param {Array<string> | null} [lifecycleStages] Filter by AI lifecycle stages.
         * @param {Array<string> | null} [frameworkCodes] Filter by framework codes.
         * @param {Array<string> | null} [ownerIds] Filter by project owner user IDs.
         * @param {Array<AISystemCurrentState> | null} [currentStates] Filter by one or more current states.
         * @param {Array<AISystemRunScope> | null} [runScopes] Filter by run scopes; a project matches when it has any of them.
         * @param {Array<GeographicScope> | null} [geographicScopes] Filter by geographic scopes; a project matches when it has any of them.
         * @param {Array<AISystemRegistrationStatus> | null} [registrationStatus] Filter by one or more registration statuses.
         * @param {string | null} [createdById] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectsExpanded: async (page?: number, size?: number, sortBy?: ProjectExpandedSorting | null, descending?: boolean | null, name?: string | null, type?: ProjectType | null, lifecycleStages?: Array<string> | null, frameworkCodes?: Array<string> | null, ownerIds?: Array<string> | null, currentStates?: Array<AISystemCurrentState> | null, runScopes?: Array<AISystemRunScope> | null, geographicScopes?: Array<GeographicScope> | null, registrationStatus?: Array<AISystemRegistrationStatus> | null, createdById?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/projects/expanded`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (lifecycleStages) {
                localVarQueryParameter['lifecycle_stages'] = lifecycleStages;
            }

            if (frameworkCodes) {
                localVarQueryParameter['framework_codes'] = frameworkCodes;
            }

            if (ownerIds) {
                localVarQueryParameter['owner_ids'] = ownerIds;
            }

            if (currentStates) {
                localVarQueryParameter['current_states'] = currentStates;
            }

            if (runScopes) {
                localVarQueryParameter['run_scopes'] = runScopes;
            }

            if (geographicScopes) {
                localVarQueryParameter['geographic_scopes'] = geographicScopes;
            }

            if (registrationStatus) {
                localVarQueryParameter['registration_status'] = registrationStatus;
            }

            if (createdById !== undefined) {
                localVarQueryParameter['created_by_id'] = createdById;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create one draft AI System per CSV row in the background. Nothing is submitted or approved: every imported system waits for review as a draft.  The CSV columns are the AI System fields, so a spreadsheet export can be uploaded as it is:  - UTF-8 (a byte-order mark is tolerated); the delimiter may be `,` or `;`. - Header names are matched case-insensitively; unknown columns are ignored. - `name` is the only required column. A row without one is skipped. - `creator` (also accepted as `reporter`, `created_by` or `created_by_email`) and `owner` (also   `owners`, `assignee`, `assignees`) hold the email of a member of the target organization.   `owner` accepts several, separated by `,`, `;` or `|`. - Members who have not signed in yet count. A migration arrives before its people do, so an   invited or deactivated member is matched and given their AI Systems; only the rest of the   product requires an active, activated user. Someone outside the organization never matches. - The creator is mandatory. A row with no `creator` email, or one matching nobody in the target   organization, is skipped and reported; the person running the import is never recorded as the   creator. Owners are optional: an `owner` that matches nobody is reported as a warning and the   row is still created. A cell that is not an email at all, such as a display name, is reported   and treated as empty. - The creator is always an owner of the AI System, alongside any owner the file names. - A row whose name already exists, or which repeats a name used earlier in the same file, is   skipped. Re-uploading a corrected file therefore adds only what is new. - The organization\'s plan limit applies, exactly as it does when an AI System is created by   hand. Rows beyond the remaining allowance are skipped and reported, and an organization with   no allowance left is refused before the import starts. The preview reports what is left. - `geographic_scope` and `run_scope` accept several values separated by `,`, `;` or `|`. - `eu_ai_act_role`, `eu_ai_act_product_category` and `eu_ai_act_use_case` answer the EU AI Act   scoping questions and are stored on the AI System\'s settings, not on the system itself. Each   accepts several values separated by `,`, `;` or `|`. Roles are `Provider`, `Distributor`,   `Importer`, `Deployer` or `Authorised representative`; product categories are `AI System` or   `General Purpose AI Model`; use cases are `High Risk`, `Transparency`, `Limited Risk` or   `Minimal Risk`. - A row must give both a role and a product category for its EU AI Act settings to be stored.   A row answering only some of the three keeps its AI System, and the omission is reported. - `Minimal Risk` stands alone: a use case cell that combines it with another use case is ignored   and reported, and the row\'s role and product category are still stored. - The answers are stored, not applied: importing never rescopes controls and requirements. - `current_state` is `Proposed`, `Pilot` or `Already in use`. `target_go_live_date` uses   `YYYY-MM-DD`; `economic_value` is a number. - A cell that cannot be interpreted is left blank on the draft and reported, so an incomplete   inventory still imports. - There is no `project_type` or `registration_status` column: an import always creates a draft   AI application, so either one could only ever be ignored. - `organization_id` names the organization to import into, and is sent alongside the file. - Maximum file size: 10 MB.  Restricted to Modulos staff holding `platform:projects:import`.
         * @summary Import AI Systems from CSV
         * @param {File} file CSV file of AI Systems (max 10 MB)
         * @param {string} organizationId The customer organization the AI Systems are imported into.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProjects: async (file: File, organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('importProjects', 'file', file)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('importProjects', 'organizationId', organizationId)
            const localVarPath = `/projects/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }

            if (organizationId !== undefined) { 
                localVarFormParams.append('organization_id', organizationId as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List project roles for a user in the given project.
         * @summary List Project User Roles
         * @param {string} userId 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProjectUserRoles: async (userId: string, projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('listProjectUserRoles', 'userId', userId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('listProjectUserRoles', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/users/{user_id}/roles`
                .replace('{user_id}', encodeURIComponent(String(userId)))
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Report what a CSV file would create, without creating anything.  The CSV columns are the AI System fields, so a spreadsheet export can be uploaded as it is:  - UTF-8 (a byte-order mark is tolerated); the delimiter may be `,` or `;`. - Header names are matched case-insensitively; unknown columns are ignored. - `name` is the only required column. A row without one is skipped. - `creator` (also accepted as `reporter`, `created_by` or `created_by_email`) and `owner` (also   `owners`, `assignee`, `assignees`) hold the email of a member of the target organization.   `owner` accepts several, separated by `,`, `;` or `|`. - Members who have not signed in yet count. A migration arrives before its people do, so an   invited or deactivated member is matched and given their AI Systems; only the rest of the   product requires an active, activated user. Someone outside the organization never matches. - The creator is mandatory. A row with no `creator` email, or one matching nobody in the target   organization, is skipped and reported; the person running the import is never recorded as the   creator. Owners are optional: an `owner` that matches nobody is reported as a warning and the   row is still created. A cell that is not an email at all, such as a display name, is reported   and treated as empty. - The creator is always an owner of the AI System, alongside any owner the file names. - A row whose name already exists, or which repeats a name used earlier in the same file, is   skipped. Re-uploading a corrected file therefore adds only what is new. - The organization\'s plan limit applies, exactly as it does when an AI System is created by   hand. Rows beyond the remaining allowance are skipped and reported, and an organization with   no allowance left is refused before the import starts. The preview reports what is left. - `geographic_scope` and `run_scope` accept several values separated by `,`, `;` or `|`. - `eu_ai_act_role`, `eu_ai_act_product_category` and `eu_ai_act_use_case` answer the EU AI Act   scoping questions and are stored on the AI System\'s settings, not on the system itself. Each   accepts several values separated by `,`, `;` or `|`. Roles are `Provider`, `Distributor`,   `Importer`, `Deployer` or `Authorised representative`; product categories are `AI System` or   `General Purpose AI Model`; use cases are `High Risk`, `Transparency`, `Limited Risk` or   `Minimal Risk`. - A row must give both a role and a product category for its EU AI Act settings to be stored.   A row answering only some of the three keeps its AI System, and the omission is reported. - `Minimal Risk` stands alone: a use case cell that combines it with another use case is ignored   and reported, and the row\'s role and product category are still stored. - The answers are stored, not applied: importing never rescopes controls and requirements. - `current_state` is `Proposed`, `Pilot` or `Already in use`. `target_go_live_date` uses   `YYYY-MM-DD`; `economic_value` is a number. - A cell that cannot be interpreted is left blank on the draft and reported, so an incomplete   inventory still imports. - There is no `project_type` or `registration_status` column: an import always creates a draft   AI application, so either one could only ever be ignored. - `organization_id` names the organization to import into, and is sent alongside the file. - Maximum file size: 10 MB.  Restricted to Modulos staff holding `platform:projects:import`.
         * @summary Preview a CSV import of AI Systems
         * @param {File} file CSV file of AI Systems (max 10 MB)
         * @param {string} organizationId The customer organization the AI Systems are imported into.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewProjectsImport: async (file: File, organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('previewProjectsImport', 'file', file)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('previewProjectsImport', 'organizationId', organizationId)
            const localVarPath = `/projects/import/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }

            if (organizationId !== undefined) { 
                localVarFormParams.append('organization_id', organizationId as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a user from the project by clearing all their project roles.
         * @summary Remove Project User
         * @param {string} projectId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeProjectUser: async (projectId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('removeProjectUser', 'projectId', projectId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeProjectUser', 'userId', userId)
            const localVarPath = `/projects/{project_id}/users/{user_id}`
                .replace('{project_id}', encodeURIComponent(String(projectId)))
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a single project role from a user.
         * @summary Remove Project User Role
         * @param {Roles} roleName 
         * @param {string} userId 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeProjectUserRole: async (roleName: Roles, userId: string, projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleName' is not null or undefined
            assertParamExists('removeProjectUserRole', 'roleName', roleName)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeProjectUserRole', 'userId', userId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('removeProjectUserRole', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/users/{user_id}/roles/{role_name}`
                .replace('{role_name}', encodeURIComponent(String(roleName)))
                .replace('{user_id}', encodeURIComponent(String(userId)))
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Project
         * @param {string} projectId 
         * @param {ProjectUpdate} projectUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject: async (projectId: string, projectUpdate: ProjectUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('updateProject', 'projectId', projectId)
            // verify required parameter 'projectUpdate' is not null or undefined
            assertParamExists('updateProject', 'projectUpdate', projectUpdate)
            const localVarPath = `/projects/{project_id}`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Move the AI System through its registration workflow: draft → pending → approved | rejected → pending.
         * @summary Update Project Registration Status
         * @param {string} projectId 
         * @param {ProjectRegistrationStatusUpdate} projectRegistrationStatusUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectRegistrationStatus: async (projectId: string, projectRegistrationStatusUpdate: ProjectRegistrationStatusUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('updateProjectRegistrationStatus', 'projectId', projectId)
            // verify required parameter 'projectRegistrationStatusUpdate' is not null or undefined
            assertParamExists('updateProjectRegistrationStatus', 'projectRegistrationStatusUpdate', projectRegistrationStatusUpdate)
            const localVarPath = `/projects/{project_id}/registration-status`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectRegistrationStatusUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectsApi - functional programming interface
 */
export const ProjectsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectsApiAxiosParamCreator(configuration)
    return {
        /**
         * Assign project roles to a user.
         * @summary Add Project User Role
         * @param {string} userId 
         * @param {string} projectId 
         * @param {ProjectUserRoleUpdate} projectUserRoleUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addProjectUserRole(userId: string, projectId: string, projectUserRoleUpdate: ProjectUserRoleUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addProjectUserRole(userId, projectId, projectUserRoleUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.addProjectUserRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add user to project
         * @summary Add Project User To Project
         * @param {string} projectId 
         * @param {AddProjectUserToProject} addProjectUserToProject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addProjectUserToProject(projectId: string, addProjectUserToProject: AddProjectUserToProject, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addProjectUserToProject(projectId, addProjectUserToProject, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.addProjectUserToProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bulk update requirements.
         * @summary Bulk Update Requirements
         * @param {string} projectId 
         * @param {BulkUpdateRequirementsRequest} bulkUpdateRequirementsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateRequirements(projectId: string, bulkUpdateRequirementsRequest: BulkUpdateRequirementsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateRequirements(projectId, bulkUpdateRequirementsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.bulkUpdateRequirements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new project.
         * @summary Create Project
         * @param {ProjectCreate} projectCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProject(projectCreate: ProjectCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProject(projectCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.createProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a comment to the AI system and notify its owners and prior participants.
         * @summary Create Project Comment
         * @param {string} projectId 
         * @param {AddCommentRequest} addCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProjectComment(projectId: string, addCommentRequest: AddCommentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Comment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProjectComment(projectId, addCommentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.createProjectComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Project Frameworks Endpoint
         * @param {string} projectId 
         * @param {ProjectFrameworkCreateRequest} projectFrameworkCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProjectFrameworksEndpoint(projectId: string, projectFrameworkCreateRequest: ProjectFrameworkCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Framework>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProjectFrameworksEndpoint(projectId, projectFrameworkCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.createProjectFrameworksEndpoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a project by ID.  ``projects:delete`` deletes it in any registration status. While an AI System is not registered (draft, pending or rejected), its creator and the organization\'s registration reviewers may delete it too.
         * @summary Delete Project
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProject(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProject(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.deleteProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Project
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProject(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProject(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Comments left on the AI system itself (not on its controls, risks or assets).
         * @summary Get Project Comments
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectComments(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Comment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectComments(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getProjectComments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all frameworks for a project.
         * @summary Get Project Frameworks
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [sortBy] 
         * @param {string | null} [sortDir] 
         * @param {string | null} [name] 
         * @param {boolean | null} [isFrameworkLatestVersion] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectFrameworks(projectId: string, page?: number, size?: number, sortBy?: string | null, sortDir?: string | null, name?: string | null, isFrameworkLatestVersion?: boolean | null, exactMatch?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResultFramework>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectFrameworks(projectId, page, size, sortBy, sortDir, name, isFrameworkLatestVersion, exactMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getProjectFrameworks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get activity logs for an AI system.
         * @summary Get AI System Logs
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectLogs(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Log>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectLogs(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getProjectLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Project Requirements
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [sortBy] 
         * @param {string | null} [sortDir] 
         * @param {string | null} [name] 
         * @param {string | null} [assignedTo] 
         * @param {string | null} [frameworkCode] 
         * @param {RequirementStatus | null} [status] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectRequirements(projectId: string, page?: number, size?: number, sortBy?: string | null, sortDir?: string | null, name?: string | null, assignedTo?: string | null, frameworkCode?: string | null, status?: RequirementStatus | null, exactMatch?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResultRequirementBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectRequirements(projectId, page, size, sortBy, sortDir, name, assignedTo, frameworkCode, status, exactMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getProjectRequirements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List users who have a role on the project (paginated).
         * @summary Get Project Users
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {UserSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrEmail] 
         * @param {Roles | null} [role] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectUsers(projectId: string, page?: number, size?: number, sortBy?: UserSorting | null, descending?: boolean | null, nameOrEmail?: string | null, role?: Roles | null, exactMatch?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectUserPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectUsers(projectId, page, size, sortBy, descending, nameOrEmail, role, exactMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getProjectUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get projects.
         * @summary Get Projects
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {ProjectSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [name] 
         * @param {ProjectType | null} [type] 
         * @param {Array<string> | null} [lifecycleStages] Filter by AI lifecycle stages.
         * @param {Array<AISystemRegistrationStatus> | null} [registrationStatus] Filter by one or more registration statuses.
         * @param {string | null} [createdById] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjects(page?: number, size?: number, sortBy?: ProjectSorting | null, descending?: boolean | null, name?: string | null, type?: ProjectType | null, lifecycleStages?: Array<string> | null, registrationStatus?: Array<AISystemRegistrationStatus> | null, createdById?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjects(page, size, sortBy, descending, name, type, lifecycleStages, registrationStatus, createdById, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getProjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get expanded projects.
         * @summary Get Projects Expanded
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {ProjectExpandedSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [name] 
         * @param {ProjectType | null} [type] 
         * @param {Array<string> | null} [lifecycleStages] Filter by AI lifecycle stages.
         * @param {Array<string> | null} [frameworkCodes] Filter by framework codes.
         * @param {Array<string> | null} [ownerIds] Filter by project owner user IDs.
         * @param {Array<AISystemCurrentState> | null} [currentStates] Filter by one or more current states.
         * @param {Array<AISystemRunScope> | null} [runScopes] Filter by run scopes; a project matches when it has any of them.
         * @param {Array<GeographicScope> | null} [geographicScopes] Filter by geographic scopes; a project matches when it has any of them.
         * @param {Array<AISystemRegistrationStatus> | null} [registrationStatus] Filter by one or more registration statuses.
         * @param {string | null} [createdById] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectsExpanded(page?: number, size?: number, sortBy?: ProjectExpandedSorting | null, descending?: boolean | null, name?: string | null, type?: ProjectType | null, lifecycleStages?: Array<string> | null, frameworkCodes?: Array<string> | null, ownerIds?: Array<string> | null, currentStates?: Array<AISystemCurrentState> | null, runScopes?: Array<AISystemRunScope> | null, geographicScopes?: Array<GeographicScope> | null, registrationStatus?: Array<AISystemRegistrationStatus> | null, createdById?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectExpandedPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectsExpanded(page, size, sortBy, descending, name, type, lifecycleStages, frameworkCodes, ownerIds, currentStates, runScopes, geographicScopes, registrationStatus, createdById, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getProjectsExpanded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create one draft AI System per CSV row in the background. Nothing is submitted or approved: every imported system waits for review as a draft.  The CSV columns are the AI System fields, so a spreadsheet export can be uploaded as it is:  - UTF-8 (a byte-order mark is tolerated); the delimiter may be `,` or `;`. - Header names are matched case-insensitively; unknown columns are ignored. - `name` is the only required column. A row without one is skipped. - `creator` (also accepted as `reporter`, `created_by` or `created_by_email`) and `owner` (also   `owners`, `assignee`, `assignees`) hold the email of a member of the target organization.   `owner` accepts several, separated by `,`, `;` or `|`. - Members who have not signed in yet count. A migration arrives before its people do, so an   invited or deactivated member is matched and given their AI Systems; only the rest of the   product requires an active, activated user. Someone outside the organization never matches. - The creator is mandatory. A row with no `creator` email, or one matching nobody in the target   organization, is skipped and reported; the person running the import is never recorded as the   creator. Owners are optional: an `owner` that matches nobody is reported as a warning and the   row is still created. A cell that is not an email at all, such as a display name, is reported   and treated as empty. - The creator is always an owner of the AI System, alongside any owner the file names. - A row whose name already exists, or which repeats a name used earlier in the same file, is   skipped. Re-uploading a corrected file therefore adds only what is new. - The organization\'s plan limit applies, exactly as it does when an AI System is created by   hand. Rows beyond the remaining allowance are skipped and reported, and an organization with   no allowance left is refused before the import starts. The preview reports what is left. - `geographic_scope` and `run_scope` accept several values separated by `,`, `;` or `|`. - `eu_ai_act_role`, `eu_ai_act_product_category` and `eu_ai_act_use_case` answer the EU AI Act   scoping questions and are stored on the AI System\'s settings, not on the system itself. Each   accepts several values separated by `,`, `;` or `|`. Roles are `Provider`, `Distributor`,   `Importer`, `Deployer` or `Authorised representative`; product categories are `AI System` or   `General Purpose AI Model`; use cases are `High Risk`, `Transparency`, `Limited Risk` or   `Minimal Risk`. - A row must give both a role and a product category for its EU AI Act settings to be stored.   A row answering only some of the three keeps its AI System, and the omission is reported. - `Minimal Risk` stands alone: a use case cell that combines it with another use case is ignored   and reported, and the row\'s role and product category are still stored. - The answers are stored, not applied: importing never rescopes controls and requirements. - `current_state` is `Proposed`, `Pilot` or `Already in use`. `target_go_live_date` uses   `YYYY-MM-DD`; `economic_value` is a number. - A cell that cannot be interpreted is left blank on the draft and reported, so an incomplete   inventory still imports. - There is no `project_type` or `registration_status` column: an import always creates a draft   AI application, so either one could only ever be ignored. - `organization_id` names the organization to import into, and is sent alongside the file. - Maximum file size: 10 MB.  Restricted to Modulos staff holding `platform:projects:import`.
         * @summary Import AI Systems from CSV
         * @param {File} file CSV file of AI Systems (max 10 MB)
         * @param {string} organizationId The customer organization the AI Systems are imported into.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importProjects(file: File, organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectImportAccepted>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importProjects(file, organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.importProjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List project roles for a user in the given project.
         * @summary List Project User Roles
         * @param {string} userId 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listProjectUserRoles(userId: string, projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Roles>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listProjectUserRoles(userId, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.listProjectUserRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Report what a CSV file would create, without creating anything.  The CSV columns are the AI System fields, so a spreadsheet export can be uploaded as it is:  - UTF-8 (a byte-order mark is tolerated); the delimiter may be `,` or `;`. - Header names are matched case-insensitively; unknown columns are ignored. - `name` is the only required column. A row without one is skipped. - `creator` (also accepted as `reporter`, `created_by` or `created_by_email`) and `owner` (also   `owners`, `assignee`, `assignees`) hold the email of a member of the target organization.   `owner` accepts several, separated by `,`, `;` or `|`. - Members who have not signed in yet count. A migration arrives before its people do, so an   invited or deactivated member is matched and given their AI Systems; only the rest of the   product requires an active, activated user. Someone outside the organization never matches. - The creator is mandatory. A row with no `creator` email, or one matching nobody in the target   organization, is skipped and reported; the person running the import is never recorded as the   creator. Owners are optional: an `owner` that matches nobody is reported as a warning and the   row is still created. A cell that is not an email at all, such as a display name, is reported   and treated as empty. - The creator is always an owner of the AI System, alongside any owner the file names. - A row whose name already exists, or which repeats a name used earlier in the same file, is   skipped. Re-uploading a corrected file therefore adds only what is new. - The organization\'s plan limit applies, exactly as it does when an AI System is created by   hand. Rows beyond the remaining allowance are skipped and reported, and an organization with   no allowance left is refused before the import starts. The preview reports what is left. - `geographic_scope` and `run_scope` accept several values separated by `,`, `;` or `|`. - `eu_ai_act_role`, `eu_ai_act_product_category` and `eu_ai_act_use_case` answer the EU AI Act   scoping questions and are stored on the AI System\'s settings, not on the system itself. Each   accepts several values separated by `,`, `;` or `|`. Roles are `Provider`, `Distributor`,   `Importer`, `Deployer` or `Authorised representative`; product categories are `AI System` or   `General Purpose AI Model`; use cases are `High Risk`, `Transparency`, `Limited Risk` or   `Minimal Risk`. - A row must give both a role and a product category for its EU AI Act settings to be stored.   A row answering only some of the three keeps its AI System, and the omission is reported. - `Minimal Risk` stands alone: a use case cell that combines it with another use case is ignored   and reported, and the row\'s role and product category are still stored. - The answers are stored, not applied: importing never rescopes controls and requirements. - `current_state` is `Proposed`, `Pilot` or `Already in use`. `target_go_live_date` uses   `YYYY-MM-DD`; `economic_value` is a number. - A cell that cannot be interpreted is left blank on the draft and reported, so an incomplete   inventory still imports. - There is no `project_type` or `registration_status` column: an import always creates a draft   AI application, so either one could only ever be ignored. - `organization_id` names the organization to import into, and is sent alongside the file. - Maximum file size: 10 MB.  Restricted to Modulos staff holding `platform:projects:import`.
         * @summary Preview a CSV import of AI Systems
         * @param {File} file CSV file of AI Systems (max 10 MB)
         * @param {string} organizationId The customer organization the AI Systems are imported into.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewProjectsImport(file: File, organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectImportPreview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewProjectsImport(file, organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.previewProjectsImport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a user from the project by clearing all their project roles.
         * @summary Remove Project User
         * @param {string} projectId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeProjectUser(projectId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeProjectUser(projectId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.removeProjectUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a single project role from a user.
         * @summary Remove Project User Role
         * @param {Roles} roleName 
         * @param {string} userId 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeProjectUserRole(roleName: Roles, userId: string, projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeProjectUserRole(roleName, userId, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.removeProjectUserRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Project
         * @param {string} projectId 
         * @param {ProjectUpdate} projectUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProject(projectId: string, projectUpdate: ProjectUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProject(projectId, projectUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.updateProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Move the AI System through its registration workflow: draft → pending → approved | rejected → pending.
         * @summary Update Project Registration Status
         * @param {string} projectId 
         * @param {ProjectRegistrationStatusUpdate} projectRegistrationStatusUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProjectRegistrationStatus(projectId: string, projectRegistrationStatusUpdate: ProjectRegistrationStatusUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProjectRegistrationStatus(projectId, projectRegistrationStatusUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.updateProjectRegistrationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProjectsApi - factory interface
 */
export const ProjectsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectsApiFp(configuration)
    return {
        /**
         * Assign project roles to a user.
         * @summary Add Project User Role
         * @param {ProjectsApiAddProjectUserRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProjectUserRole(requestParameters: ProjectsApiAddProjectUserRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectUser> {
            return localVarFp.addProjectUserRole(requestParameters.userId, requestParameters.projectId, requestParameters.projectUserRoleUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Add user to project
         * @summary Add Project User To Project
         * @param {ProjectsApiAddProjectUserToProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProjectUserToProject(requestParameters: ProjectsApiAddProjectUserToProjectRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectUser> {
            return localVarFp.addProjectUserToProject(requestParameters.projectId, requestParameters.addProjectUserToProject, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk update requirements.
         * @summary Bulk Update Requirements
         * @param {ProjectsApiBulkUpdateRequirementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateRequirements(requestParameters: ProjectsApiBulkUpdateRequirementsRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.bulkUpdateRequirements(requestParameters.projectId, requestParameters.bulkUpdateRequirementsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new project.
         * @summary Create Project
         * @param {ProjectsApiCreateProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject(requestParameters: ProjectsApiCreateProjectRequest, options?: RawAxiosRequestConfig): AxiosPromise<Project> {
            return localVarFp.createProject(requestParameters.projectCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a comment to the AI system and notify its owners and prior participants.
         * @summary Create Project Comment
         * @param {ProjectsApiCreateProjectCommentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectComment(requestParameters: ProjectsApiCreateProjectCommentRequest, options?: RawAxiosRequestConfig): AxiosPromise<Comment> {
            return localVarFp.createProjectComment(requestParameters.projectId, requestParameters.addCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Project Frameworks Endpoint
         * @param {ProjectsApiCreateProjectFrameworksEndpointRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectFrameworksEndpoint(requestParameters: ProjectsApiCreateProjectFrameworksEndpointRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Framework>> {
            return localVarFp.createProjectFrameworksEndpoint(requestParameters.projectId, requestParameters.projectFrameworkCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a project by ID.  ``projects:delete`` deletes it in any registration status. While an AI System is not registered (draft, pending or rejected), its creator and the organization\'s registration reviewers may delete it too.
         * @summary Delete Project
         * @param {ProjectsApiDeleteProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject(requestParameters: ProjectsApiDeleteProjectRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteProject(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Project
         * @param {ProjectsApiGetProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProject(requestParameters: ProjectsApiGetProjectRequest, options?: RawAxiosRequestConfig): AxiosPromise<Project> {
            return localVarFp.getProject(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Comments left on the AI system itself (not on its controls, risks or assets).
         * @summary Get Project Comments
         * @param {ProjectsApiGetProjectCommentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectComments(requestParameters: ProjectsApiGetProjectCommentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Comment>> {
            return localVarFp.getProjectComments(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all frameworks for a project.
         * @summary Get Project Frameworks
         * @param {ProjectsApiGetProjectFrameworksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectFrameworks(requestParameters: ProjectsApiGetProjectFrameworksRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResultFramework> {
            return localVarFp.getProjectFrameworks(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.sortDir, requestParameters.name, requestParameters.isFrameworkLatestVersion, requestParameters.exactMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Get activity logs for an AI system.
         * @summary Get AI System Logs
         * @param {ProjectsApiGetProjectLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectLogs(requestParameters: ProjectsApiGetProjectLogsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Log>> {
            return localVarFp.getProjectLogs(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Project Requirements
         * @param {ProjectsApiGetProjectRequirementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectRequirements(requestParameters: ProjectsApiGetProjectRequirementsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResultRequirementBase> {
            return localVarFp.getProjectRequirements(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.sortDir, requestParameters.name, requestParameters.assignedTo, requestParameters.frameworkCode, requestParameters.status, requestParameters.exactMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * List users who have a role on the project (paginated).
         * @summary Get Project Users
         * @param {ProjectsApiGetProjectUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectUsers(requestParameters: ProjectsApiGetProjectUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectUserPaginated> {
            return localVarFp.getProjectUsers(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrEmail, requestParameters.role, requestParameters.exactMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Get projects.
         * @summary Get Projects
         * @param {ProjectsApiGetProjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjects(requestParameters: ProjectsApiGetProjectsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ProjectPaginated> {
            return localVarFp.getProjects(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.name, requestParameters.type, requestParameters.lifecycleStages, requestParameters.registrationStatus, requestParameters.createdById, options).then((request) => request(axios, basePath));
        },
        /**
         * Get expanded projects.
         * @summary Get Projects Expanded
         * @param {ProjectsApiGetProjectsExpandedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectsExpanded(requestParameters: ProjectsApiGetProjectsExpandedRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ProjectExpandedPaginated> {
            return localVarFp.getProjectsExpanded(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.name, requestParameters.type, requestParameters.lifecycleStages, requestParameters.frameworkCodes, requestParameters.ownerIds, requestParameters.currentStates, requestParameters.runScopes, requestParameters.geographicScopes, requestParameters.registrationStatus, requestParameters.createdById, options).then((request) => request(axios, basePath));
        },
        /**
         * Create one draft AI System per CSV row in the background. Nothing is submitted or approved: every imported system waits for review as a draft.  The CSV columns are the AI System fields, so a spreadsheet export can be uploaded as it is:  - UTF-8 (a byte-order mark is tolerated); the delimiter may be `,` or `;`. - Header names are matched case-insensitively; unknown columns are ignored. - `name` is the only required column. A row without one is skipped. - `creator` (also accepted as `reporter`, `created_by` or `created_by_email`) and `owner` (also   `owners`, `assignee`, `assignees`) hold the email of a member of the target organization.   `owner` accepts several, separated by `,`, `;` or `|`. - Members who have not signed in yet count. A migration arrives before its people do, so an   invited or deactivated member is matched and given their AI Systems; only the rest of the   product requires an active, activated user. Someone outside the organization never matches. - The creator is mandatory. A row with no `creator` email, or one matching nobody in the target   organization, is skipped and reported; the person running the import is never recorded as the   creator. Owners are optional: an `owner` that matches nobody is reported as a warning and the   row is still created. A cell that is not an email at all, such as a display name, is reported   and treated as empty. - The creator is always an owner of the AI System, alongside any owner the file names. - A row whose name already exists, or which repeats a name used earlier in the same file, is   skipped. Re-uploading a corrected file therefore adds only what is new. - The organization\'s plan limit applies, exactly as it does when an AI System is created by   hand. Rows beyond the remaining allowance are skipped and reported, and an organization with   no allowance left is refused before the import starts. The preview reports what is left. - `geographic_scope` and `run_scope` accept several values separated by `,`, `;` or `|`. - `eu_ai_act_role`, `eu_ai_act_product_category` and `eu_ai_act_use_case` answer the EU AI Act   scoping questions and are stored on the AI System\'s settings, not on the system itself. Each   accepts several values separated by `,`, `;` or `|`. Roles are `Provider`, `Distributor`,   `Importer`, `Deployer` or `Authorised representative`; product categories are `AI System` or   `General Purpose AI Model`; use cases are `High Risk`, `Transparency`, `Limited Risk` or   `Minimal Risk`. - A row must give both a role and a product category for its EU AI Act settings to be stored.   A row answering only some of the three keeps its AI System, and the omission is reported. - `Minimal Risk` stands alone: a use case cell that combines it with another use case is ignored   and reported, and the row\'s role and product category are still stored. - The answers are stored, not applied: importing never rescopes controls and requirements. - `current_state` is `Proposed`, `Pilot` or `Already in use`. `target_go_live_date` uses   `YYYY-MM-DD`; `economic_value` is a number. - A cell that cannot be interpreted is left blank on the draft and reported, so an incomplete   inventory still imports. - There is no `project_type` or `registration_status` column: an import always creates a draft   AI application, so either one could only ever be ignored. - `organization_id` names the organization to import into, and is sent alongside the file. - Maximum file size: 10 MB.  Restricted to Modulos staff holding `platform:projects:import`.
         * @summary Import AI Systems from CSV
         * @param {ProjectsApiImportProjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProjects(requestParameters: ProjectsApiImportProjectsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectImportAccepted> {
            return localVarFp.importProjects(requestParameters.file, requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * List project roles for a user in the given project.
         * @summary List Project User Roles
         * @param {ProjectsApiListProjectUserRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProjectUserRoles(requestParameters: ProjectsApiListProjectUserRolesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Roles>> {
            return localVarFp.listProjectUserRoles(requestParameters.userId, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Report what a CSV file would create, without creating anything.  The CSV columns are the AI System fields, so a spreadsheet export can be uploaded as it is:  - UTF-8 (a byte-order mark is tolerated); the delimiter may be `,` or `;`. - Header names are matched case-insensitively; unknown columns are ignored. - `name` is the only required column. A row without one is skipped. - `creator` (also accepted as `reporter`, `created_by` or `created_by_email`) and `owner` (also   `owners`, `assignee`, `assignees`) hold the email of a member of the target organization.   `owner` accepts several, separated by `,`, `;` or `|`. - Members who have not signed in yet count. A migration arrives before its people do, so an   invited or deactivated member is matched and given their AI Systems; only the rest of the   product requires an active, activated user. Someone outside the organization never matches. - The creator is mandatory. A row with no `creator` email, or one matching nobody in the target   organization, is skipped and reported; the person running the import is never recorded as the   creator. Owners are optional: an `owner` that matches nobody is reported as a warning and the   row is still created. A cell that is not an email at all, such as a display name, is reported   and treated as empty. - The creator is always an owner of the AI System, alongside any owner the file names. - A row whose name already exists, or which repeats a name used earlier in the same file, is   skipped. Re-uploading a corrected file therefore adds only what is new. - The organization\'s plan limit applies, exactly as it does when an AI System is created by   hand. Rows beyond the remaining allowance are skipped and reported, and an organization with   no allowance left is refused before the import starts. The preview reports what is left. - `geographic_scope` and `run_scope` accept several values separated by `,`, `;` or `|`. - `eu_ai_act_role`, `eu_ai_act_product_category` and `eu_ai_act_use_case` answer the EU AI Act   scoping questions and are stored on the AI System\'s settings, not on the system itself. Each   accepts several values separated by `,`, `;` or `|`. Roles are `Provider`, `Distributor`,   `Importer`, `Deployer` or `Authorised representative`; product categories are `AI System` or   `General Purpose AI Model`; use cases are `High Risk`, `Transparency`, `Limited Risk` or   `Minimal Risk`. - A row must give both a role and a product category for its EU AI Act settings to be stored.   A row answering only some of the three keeps its AI System, and the omission is reported. - `Minimal Risk` stands alone: a use case cell that combines it with another use case is ignored   and reported, and the row\'s role and product category are still stored. - The answers are stored, not applied: importing never rescopes controls and requirements. - `current_state` is `Proposed`, `Pilot` or `Already in use`. `target_go_live_date` uses   `YYYY-MM-DD`; `economic_value` is a number. - A cell that cannot be interpreted is left blank on the draft and reported, so an incomplete   inventory still imports. - There is no `project_type` or `registration_status` column: an import always creates a draft   AI application, so either one could only ever be ignored. - `organization_id` names the organization to import into, and is sent alongside the file. - Maximum file size: 10 MB.  Restricted to Modulos staff holding `platform:projects:import`.
         * @summary Preview a CSV import of AI Systems
         * @param {ProjectsApiPreviewProjectsImportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewProjectsImport(requestParameters: ProjectsApiPreviewProjectsImportRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectImportPreview> {
            return localVarFp.previewProjectsImport(requestParameters.file, requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a user from the project by clearing all their project roles.
         * @summary Remove Project User
         * @param {ProjectsApiRemoveProjectUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeProjectUser(requestParameters: ProjectsApiRemoveProjectUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeProjectUser(requestParameters.projectId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a single project role from a user.
         * @summary Remove Project User Role
         * @param {ProjectsApiRemoveProjectUserRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeProjectUserRole(requestParameters: ProjectsApiRemoveProjectUserRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeProjectUserRole(requestParameters.roleName, requestParameters.userId, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Project
         * @param {ProjectsApiUpdateProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject(requestParameters: ProjectsApiUpdateProjectRequest, options?: RawAxiosRequestConfig): AxiosPromise<Project> {
            return localVarFp.updateProject(requestParameters.projectId, requestParameters.projectUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Move the AI System through its registration workflow: draft → pending → approved | rejected → pending.
         * @summary Update Project Registration Status
         * @param {ProjectsApiUpdateProjectRegistrationStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectRegistrationStatus(requestParameters: ProjectsApiUpdateProjectRegistrationStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<Project> {
            return localVarFp.updateProjectRegistrationStatus(requestParameters.projectId, requestParameters.projectRegistrationStatusUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addProjectUserRole operation in ProjectsApi.
 */
export interface ProjectsApiAddProjectUserRoleRequest {
    readonly userId: string

    readonly projectId: string

    readonly projectUserRoleUpdate: ProjectUserRoleUpdate
}

/**
 * Request parameters for addProjectUserToProject operation in ProjectsApi.
 */
export interface ProjectsApiAddProjectUserToProjectRequest {
    readonly projectId: string

    readonly addProjectUserToProject: AddProjectUserToProject
}

/**
 * Request parameters for bulkUpdateRequirements operation in ProjectsApi.
 */
export interface ProjectsApiBulkUpdateRequirementsRequest {
    readonly projectId: string

    readonly bulkUpdateRequirementsRequest: BulkUpdateRequirementsRequest
}

/**
 * Request parameters for createProject operation in ProjectsApi.
 */
export interface ProjectsApiCreateProjectRequest {
    readonly projectCreate: ProjectCreate
}

/**
 * Request parameters for createProjectComment operation in ProjectsApi.
 */
export interface ProjectsApiCreateProjectCommentRequest {
    readonly projectId: string

    readonly addCommentRequest: AddCommentRequest
}

/**
 * Request parameters for createProjectFrameworksEndpoint operation in ProjectsApi.
 */
export interface ProjectsApiCreateProjectFrameworksEndpointRequest {
    readonly projectId: string

    readonly projectFrameworkCreateRequest: ProjectFrameworkCreateRequest
}

/**
 * Request parameters for deleteProject operation in ProjectsApi.
 */
export interface ProjectsApiDeleteProjectRequest {
    readonly projectId: string
}

/**
 * Request parameters for getProject operation in ProjectsApi.
 */
export interface ProjectsApiGetProjectRequest {
    readonly projectId: string
}

/**
 * Request parameters for getProjectComments operation in ProjectsApi.
 */
export interface ProjectsApiGetProjectCommentsRequest {
    readonly projectId: string
}

/**
 * Request parameters for getProjectFrameworks operation in ProjectsApi.
 */
export interface ProjectsApiGetProjectFrameworksRequest {
    readonly projectId: string

    readonly page?: number

    readonly size?: number

    readonly sortBy?: string | null

    readonly sortDir?: string | null

    readonly name?: string | null

    readonly isFrameworkLatestVersion?: boolean | null

    readonly exactMatch?: boolean
}

/**
 * Request parameters for getProjectLogs operation in ProjectsApi.
 */
export interface ProjectsApiGetProjectLogsRequest {
    readonly projectId: string
}

/**
 * Request parameters for getProjectRequirements operation in ProjectsApi.
 */
export interface ProjectsApiGetProjectRequirementsRequest {
    readonly projectId: string

    readonly page?: number

    readonly size?: number

    readonly sortBy?: string | null

    readonly sortDir?: string | null

    readonly name?: string | null

    readonly assignedTo?: string | null

    readonly frameworkCode?: string | null

    readonly status?: RequirementStatus | null

    readonly exactMatch?: boolean
}

/**
 * Request parameters for getProjectUsers operation in ProjectsApi.
 */
export interface ProjectsApiGetProjectUsersRequest {
    readonly projectId: string

    readonly page?: number

    readonly size?: number

    readonly sortBy?: UserSorting | null

    readonly descending?: boolean | null

    readonly nameOrEmail?: string | null

    readonly role?: Roles | null

    readonly exactMatch?: boolean
}

/**
 * Request parameters for getProjects operation in ProjectsApi.
 */
export interface ProjectsApiGetProjectsRequest {
    readonly page?: number

    readonly size?: number

    readonly sortBy?: ProjectSorting | null

    readonly descending?: boolean | null

    readonly name?: string | null

    readonly type?: ProjectType | null

    /**
     * Filter by AI lifecycle stages.
     */
    readonly lifecycleStages?: Array<string> | null

    /**
     * Filter by one or more registration statuses.
     */
    readonly registrationStatus?: Array<AISystemRegistrationStatus> | null

    readonly createdById?: string | null
}

/**
 * Request parameters for getProjectsExpanded operation in ProjectsApi.
 */
export interface ProjectsApiGetProjectsExpandedRequest {
    readonly page?: number

    readonly size?: number

    readonly sortBy?: ProjectExpandedSorting | null

    readonly descending?: boolean | null

    readonly name?: string | null

    readonly type?: ProjectType | null

    /**
     * Filter by AI lifecycle stages.
     */
    readonly lifecycleStages?: Array<string> | null

    /**
     * Filter by framework codes.
     */
    readonly frameworkCodes?: Array<string> | null

    /**
     * Filter by project owner user IDs.
     */
    readonly ownerIds?: Array<string> | null

    /**
     * Filter by one or more current states.
     */
    readonly currentStates?: Array<AISystemCurrentState> | null

    /**
     * Filter by run scopes; a project matches when it has any of them.
     */
    readonly runScopes?: Array<AISystemRunScope> | null

    /**
     * Filter by geographic scopes; a project matches when it has any of them.
     */
    readonly geographicScopes?: Array<GeographicScope> | null

    /**
     * Filter by one or more registration statuses.
     */
    readonly registrationStatus?: Array<AISystemRegistrationStatus> | null

    readonly createdById?: string | null
}

/**
 * Request parameters for importProjects operation in ProjectsApi.
 */
export interface ProjectsApiImportProjectsRequest {
    /**
     * CSV file of AI Systems (max 10 MB)
     */
    readonly file: File

    /**
     * The customer organization the AI Systems are imported into.
     */
    readonly organizationId: string
}

/**
 * Request parameters for listProjectUserRoles operation in ProjectsApi.
 */
export interface ProjectsApiListProjectUserRolesRequest {
    readonly userId: string

    readonly projectId: string
}

/**
 * Request parameters for previewProjectsImport operation in ProjectsApi.
 */
export interface ProjectsApiPreviewProjectsImportRequest {
    /**
     * CSV file of AI Systems (max 10 MB)
     */
    readonly file: File

    /**
     * The customer organization the AI Systems are imported into.
     */
    readonly organizationId: string
}

/**
 * Request parameters for removeProjectUser operation in ProjectsApi.
 */
export interface ProjectsApiRemoveProjectUserRequest {
    readonly projectId: string

    readonly userId: string
}

/**
 * Request parameters for removeProjectUserRole operation in ProjectsApi.
 */
export interface ProjectsApiRemoveProjectUserRoleRequest {
    readonly roleName: Roles

    readonly userId: string

    readonly projectId: string
}

/**
 * Request parameters for updateProject operation in ProjectsApi.
 */
export interface ProjectsApiUpdateProjectRequest {
    readonly projectId: string

    readonly projectUpdate: ProjectUpdate
}

/**
 * Request parameters for updateProjectRegistrationStatus operation in ProjectsApi.
 */
export interface ProjectsApiUpdateProjectRegistrationStatusRequest {
    readonly projectId: string

    readonly projectRegistrationStatusUpdate: ProjectRegistrationStatusUpdate
}

/**
 * ProjectsApi - object-oriented interface
 */
export class ProjectsApi extends BaseAPI {
    /**
     * Assign project roles to a user.
     * @summary Add Project User Role
     * @param {ProjectsApiAddProjectUserRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addProjectUserRole(requestParameters: ProjectsApiAddProjectUserRoleRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).addProjectUserRole(requestParameters.userId, requestParameters.projectId, requestParameters.projectUserRoleUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add user to project
     * @summary Add Project User To Project
     * @param {ProjectsApiAddProjectUserToProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addProjectUserToProject(requestParameters: ProjectsApiAddProjectUserToProjectRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).addProjectUserToProject(requestParameters.projectId, requestParameters.addProjectUserToProject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk update requirements.
     * @summary Bulk Update Requirements
     * @param {ProjectsApiBulkUpdateRequirementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bulkUpdateRequirements(requestParameters: ProjectsApiBulkUpdateRequirementsRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).bulkUpdateRequirements(requestParameters.projectId, requestParameters.bulkUpdateRequirementsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new project.
     * @summary Create Project
     * @param {ProjectsApiCreateProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createProject(requestParameters: ProjectsApiCreateProjectRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).createProject(requestParameters.projectCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a comment to the AI system and notify its owners and prior participants.
     * @summary Create Project Comment
     * @param {ProjectsApiCreateProjectCommentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createProjectComment(requestParameters: ProjectsApiCreateProjectCommentRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).createProjectComment(requestParameters.projectId, requestParameters.addCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Project Frameworks Endpoint
     * @param {ProjectsApiCreateProjectFrameworksEndpointRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createProjectFrameworksEndpoint(requestParameters: ProjectsApiCreateProjectFrameworksEndpointRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).createProjectFrameworksEndpoint(requestParameters.projectId, requestParameters.projectFrameworkCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a project by ID.  ``projects:delete`` deletes it in any registration status. While an AI System is not registered (draft, pending or rejected), its creator and the organization\'s registration reviewers may delete it too.
     * @summary Delete Project
     * @param {ProjectsApiDeleteProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteProject(requestParameters: ProjectsApiDeleteProjectRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).deleteProject(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Project
     * @param {ProjectsApiGetProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProject(requestParameters: ProjectsApiGetProjectRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getProject(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Comments left on the AI system itself (not on its controls, risks or assets).
     * @summary Get Project Comments
     * @param {ProjectsApiGetProjectCommentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProjectComments(requestParameters: ProjectsApiGetProjectCommentsRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getProjectComments(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all frameworks for a project.
     * @summary Get Project Frameworks
     * @param {ProjectsApiGetProjectFrameworksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProjectFrameworks(requestParameters: ProjectsApiGetProjectFrameworksRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getProjectFrameworks(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.sortDir, requestParameters.name, requestParameters.isFrameworkLatestVersion, requestParameters.exactMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get activity logs for an AI system.
     * @summary Get AI System Logs
     * @param {ProjectsApiGetProjectLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProjectLogs(requestParameters: ProjectsApiGetProjectLogsRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getProjectLogs(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Project Requirements
     * @param {ProjectsApiGetProjectRequirementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProjectRequirements(requestParameters: ProjectsApiGetProjectRequirementsRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getProjectRequirements(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.sortDir, requestParameters.name, requestParameters.assignedTo, requestParameters.frameworkCode, requestParameters.status, requestParameters.exactMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List users who have a role on the project (paginated).
     * @summary Get Project Users
     * @param {ProjectsApiGetProjectUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProjectUsers(requestParameters: ProjectsApiGetProjectUsersRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getProjectUsers(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrEmail, requestParameters.role, requestParameters.exactMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get projects.
     * @summary Get Projects
     * @param {ProjectsApiGetProjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProjects(requestParameters: ProjectsApiGetProjectsRequest = {}, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getProjects(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.name, requestParameters.type, requestParameters.lifecycleStages, requestParameters.registrationStatus, requestParameters.createdById, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get expanded projects.
     * @summary Get Projects Expanded
     * @param {ProjectsApiGetProjectsExpandedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProjectsExpanded(requestParameters: ProjectsApiGetProjectsExpandedRequest = {}, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getProjectsExpanded(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.name, requestParameters.type, requestParameters.lifecycleStages, requestParameters.frameworkCodes, requestParameters.ownerIds, requestParameters.currentStates, requestParameters.runScopes, requestParameters.geographicScopes, requestParameters.registrationStatus, requestParameters.createdById, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create one draft AI System per CSV row in the background. Nothing is submitted or approved: every imported system waits for review as a draft.  The CSV columns are the AI System fields, so a spreadsheet export can be uploaded as it is:  - UTF-8 (a byte-order mark is tolerated); the delimiter may be `,` or `;`. - Header names are matched case-insensitively; unknown columns are ignored. - `name` is the only required column. A row without one is skipped. - `creator` (also accepted as `reporter`, `created_by` or `created_by_email`) and `owner` (also   `owners`, `assignee`, `assignees`) hold the email of a member of the target organization.   `owner` accepts several, separated by `,`, `;` or `|`. - Members who have not signed in yet count. A migration arrives before its people do, so an   invited or deactivated member is matched and given their AI Systems; only the rest of the   product requires an active, activated user. Someone outside the organization never matches. - The creator is mandatory. A row with no `creator` email, or one matching nobody in the target   organization, is skipped and reported; the person running the import is never recorded as the   creator. Owners are optional: an `owner` that matches nobody is reported as a warning and the   row is still created. A cell that is not an email at all, such as a display name, is reported   and treated as empty. - The creator is always an owner of the AI System, alongside any owner the file names. - A row whose name already exists, or which repeats a name used earlier in the same file, is   skipped. Re-uploading a corrected file therefore adds only what is new. - The organization\'s plan limit applies, exactly as it does when an AI System is created by   hand. Rows beyond the remaining allowance are skipped and reported, and an organization with   no allowance left is refused before the import starts. The preview reports what is left. - `geographic_scope` and `run_scope` accept several values separated by `,`, `;` or `|`. - `eu_ai_act_role`, `eu_ai_act_product_category` and `eu_ai_act_use_case` answer the EU AI Act   scoping questions and are stored on the AI System\'s settings, not on the system itself. Each   accepts several values separated by `,`, `;` or `|`. Roles are `Provider`, `Distributor`,   `Importer`, `Deployer` or `Authorised representative`; product categories are `AI System` or   `General Purpose AI Model`; use cases are `High Risk`, `Transparency`, `Limited Risk` or   `Minimal Risk`. - A row must give both a role and a product category for its EU AI Act settings to be stored.   A row answering only some of the three keeps its AI System, and the omission is reported. - `Minimal Risk` stands alone: a use case cell that combines it with another use case is ignored   and reported, and the row\'s role and product category are still stored. - The answers are stored, not applied: importing never rescopes controls and requirements. - `current_state` is `Proposed`, `Pilot` or `Already in use`. `target_go_live_date` uses   `YYYY-MM-DD`; `economic_value` is a number. - A cell that cannot be interpreted is left blank on the draft and reported, so an incomplete   inventory still imports. - There is no `project_type` or `registration_status` column: an import always creates a draft   AI application, so either one could only ever be ignored. - `organization_id` names the organization to import into, and is sent alongside the file. - Maximum file size: 10 MB.  Restricted to Modulos staff holding `platform:projects:import`.
     * @summary Import AI Systems from CSV
     * @param {ProjectsApiImportProjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public importProjects(requestParameters: ProjectsApiImportProjectsRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).importProjects(requestParameters.file, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List project roles for a user in the given project.
     * @summary List Project User Roles
     * @param {ProjectsApiListProjectUserRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listProjectUserRoles(requestParameters: ProjectsApiListProjectUserRolesRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).listProjectUserRoles(requestParameters.userId, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Report what a CSV file would create, without creating anything.  The CSV columns are the AI System fields, so a spreadsheet export can be uploaded as it is:  - UTF-8 (a byte-order mark is tolerated); the delimiter may be `,` or `;`. - Header names are matched case-insensitively; unknown columns are ignored. - `name` is the only required column. A row without one is skipped. - `creator` (also accepted as `reporter`, `created_by` or `created_by_email`) and `owner` (also   `owners`, `assignee`, `assignees`) hold the email of a member of the target organization.   `owner` accepts several, separated by `,`, `;` or `|`. - Members who have not signed in yet count. A migration arrives before its people do, so an   invited or deactivated member is matched and given their AI Systems; only the rest of the   product requires an active, activated user. Someone outside the organization never matches. - The creator is mandatory. A row with no `creator` email, or one matching nobody in the target   organization, is skipped and reported; the person running the import is never recorded as the   creator. Owners are optional: an `owner` that matches nobody is reported as a warning and the   row is still created. A cell that is not an email at all, such as a display name, is reported   and treated as empty. - The creator is always an owner of the AI System, alongside any owner the file names. - A row whose name already exists, or which repeats a name used earlier in the same file, is   skipped. Re-uploading a corrected file therefore adds only what is new. - The organization\'s plan limit applies, exactly as it does when an AI System is created by   hand. Rows beyond the remaining allowance are skipped and reported, and an organization with   no allowance left is refused before the import starts. The preview reports what is left. - `geographic_scope` and `run_scope` accept several values separated by `,`, `;` or `|`. - `eu_ai_act_role`, `eu_ai_act_product_category` and `eu_ai_act_use_case` answer the EU AI Act   scoping questions and are stored on the AI System\'s settings, not on the system itself. Each   accepts several values separated by `,`, `;` or `|`. Roles are `Provider`, `Distributor`,   `Importer`, `Deployer` or `Authorised representative`; product categories are `AI System` or   `General Purpose AI Model`; use cases are `High Risk`, `Transparency`, `Limited Risk` or   `Minimal Risk`. - A row must give both a role and a product category for its EU AI Act settings to be stored.   A row answering only some of the three keeps its AI System, and the omission is reported. - `Minimal Risk` stands alone: a use case cell that combines it with another use case is ignored   and reported, and the row\'s role and product category are still stored. - The answers are stored, not applied: importing never rescopes controls and requirements. - `current_state` is `Proposed`, `Pilot` or `Already in use`. `target_go_live_date` uses   `YYYY-MM-DD`; `economic_value` is a number. - A cell that cannot be interpreted is left blank on the draft and reported, so an incomplete   inventory still imports. - There is no `project_type` or `registration_status` column: an import always creates a draft   AI application, so either one could only ever be ignored. - `organization_id` names the organization to import into, and is sent alongside the file. - Maximum file size: 10 MB.  Restricted to Modulos staff holding `platform:projects:import`.
     * @summary Preview a CSV import of AI Systems
     * @param {ProjectsApiPreviewProjectsImportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public previewProjectsImport(requestParameters: ProjectsApiPreviewProjectsImportRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).previewProjectsImport(requestParameters.file, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a user from the project by clearing all their project roles.
     * @summary Remove Project User
     * @param {ProjectsApiRemoveProjectUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeProjectUser(requestParameters: ProjectsApiRemoveProjectUserRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).removeProjectUser(requestParameters.projectId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a single project role from a user.
     * @summary Remove Project User Role
     * @param {ProjectsApiRemoveProjectUserRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeProjectUserRole(requestParameters: ProjectsApiRemoveProjectUserRoleRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).removeProjectUserRole(requestParameters.roleName, requestParameters.userId, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Project
     * @param {ProjectsApiUpdateProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProject(requestParameters: ProjectsApiUpdateProjectRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).updateProject(requestParameters.projectId, requestParameters.projectUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Move the AI System through its registration workflow: draft → pending → approved | rejected → pending.
     * @summary Update Project Registration Status
     * @param {ProjectsApiUpdateProjectRegistrationStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProjectRegistrationStatus(requestParameters: ProjectsApiUpdateProjectRegistrationStatusRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).updateProjectRegistrationStatus(requestParameters.projectId, requestParameters.projectRegistrationStatusUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

